import React, { useMemo, useRef, useEffect } from 'react';
import Lottie from 'lottie-react';
import animationData from 'src/assets/jsons/progress-bar.json';

interface ProgressLoaderProps {
  isComplete?: boolean;
}

export const ProgressLoader = ({ isComplete = false }: ProgressLoaderProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const lottieRef = useRef<any>(null);

  // Function to get CSS custom property value
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const getCSSCustomProperty = property => {
    return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
  };

  // Function to convert hex to normalized RGB array for Lottie
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const hexToNormalizedRGB = hex => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return [0, 0, 0, 1];

    return [parseInt(result[1], 16) / 255, parseInt(result[2], 16) / 255, parseInt(result[3], 16) / 255, 1];
  };

  const dynamicAnimationData = useMemo(() => {
    // Get colors from CSS custom properties
    const progressBarColor = getCSSCustomProperty('--progress-bar-color') || '#FECC00';
    const progressBgColor = getCSSCustomProperty('--progress-bg-color') || '#0C111D';

    const barColorRGB = hexToNormalizedRGB(progressBarColor);
    const bgColorRGB = hexToNormalizedRGB(progressBgColor);

    const modifiedData = JSON.parse(JSON.stringify(animationData));

    if (modifiedData.layers[0]?.shapes?.[0]?.it?.[1]?.c?.k) {
      modifiedData.layers[0].shapes[0].it[1].c.k = barColorRGB;
    }

    if (modifiedData.layers[1]?.shapes?.[0]?.it?.[1]?.c?.k) {
      modifiedData.layers[1].shapes[0].it[1].c.k = bgColorRGB;
    }

    return modifiedData;
  }, []);

  useEffect(() => {
    if (lottieRef.current) {
      // Make animation slower (0.3x speed)
      lottieRef.current.setSpeed(0.3);
    }
  }, []);

  useEffect(() => {
    if (isComplete && lottieRef.current) {
      // Complete the animation and stop looping
      lottieRef.current?.setLoop(false);
    }
  }, [isComplete]);

  return (
    <div style={{ width: 400, height: 16, overflow: 'visible' }}>
      <Lottie
        lottieRef={lottieRef}
        animationData={dynamicAnimationData}
        loop={!isComplete}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};
